__turbopack_context__.v({
  "active": "OjFqFa_active",
  "root": "OjFqFa_root",
  "zone": "OjFqFa_zone",
});
